import {
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import {
  AuthProvider,
} from "./context/AuthContext";

import {
  CartProvider,
} from "./context/CartContext";

import ProtectedRoute
  from "./components/ProtectedRoute";

import Layout
  from "./components/Layout";

import Home
  from "./pages/Home";

import About
  from "./pages/About";

import Coaches
  from "./pages/Coaches";

import Contact
  from "./pages/Contact";

import SignUpPage
  from "./pages/SignUpPage";

import SignInPage
  from "./pages/SignInPage";

import DashboardPage
  from "./pages/DashboardPage";

import CartPage
  from "./pages/CartPage";

import SearchResultsPage
  from "./pages/SearchResultsPage";

import OrderHistoryPage
  from "./pages/OrderHistoryPage";

import UpcomingBookingsPage
  from "./pages/UpcomingBookingsPage";

import NotFoundPage
  from "./pages/NotFoundPage";

/* ---------------------------------- */
/* APP ROUTES */
/* ---------------------------------- */

function AppRoutes() {

  const location =
    useLocation();

  const validRoutes = [

    "/",

    "/about",

    "/coaches",

    "/contact",

    "/signup",

    "/signin",

    "/dashboard",

    "/cart",

    "/bookings",

    "/history",

    "/search",
  ];

  const showLayout =
    validRoutes.includes(
      location.pathname
    );

  /* ---------------------------------- */
  /* VALID ROUTES */
  /* ---------------------------------- */

  if (showLayout) {

    return (

      <Layout>

        <Routes>

          <Route
            path="/"
            element={<Home />}
          />

          <Route
            path="/about"
            element={<About />}
          />

          <Route
            path="/coaches"
            element={<Coaches />}
          />

          <Route
            path="/contact"
            element={<Contact />}
          />

          <Route
            path="/signup"
            element={<SignUpPage />}
          />

          <Route
            path="/signin"
            element={<SignInPage />}
          />

          {/* PROTECTED */}

          <Route
            path="/dashboard"
            element={

              <ProtectedRoute>

                <DashboardPage />

              </ProtectedRoute>
            }
          />

          <Route
            path="/cart"
            element={

              <ProtectedRoute>

                <CartPage />

              </ProtectedRoute>
            }
          />

          <Route
            path="/bookings"
            element={

              <ProtectedRoute>

                <UpcomingBookingsPage />

              </ProtectedRoute>
            }
          />

          <Route
            path="/history"
            element={

              <ProtectedRoute>

                <OrderHistoryPage />

              </ProtectedRoute>
            }
          />

          <Route
            path="/search"
            element={

              <ProtectedRoute>

                <SearchResultsPage />

              </ProtectedRoute>
            }
          />

        </Routes>

      </Layout>
    );
  }

  /* ---------------------------------- */
  /* INVALID ROUTE */
  /* ---------------------------------- */

  return (

    <Routes>

      <Route
        path="*"
        element={<NotFoundPage />}
      />

    </Routes>
  );
}

/* ---------------------------------- */
/* APP */
/* ---------------------------------- */

function App() {

  return (

    <AuthProvider>

      <CartProvider>

        <AppRoutes />

      </CartProvider>

    </AuthProvider>
  );
}

export default App;